import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

const GroupWrapperV2 = ({ id, start, end, children, className }) => {
  const classes = useStyles()

  return (
    <div
      id={id}
      className={clsx(className, {
        [classes.start]: start,
        [classes.end]: end
      })}
    >
      {children}
    </div>
  )
}

export default GroupWrapperV2
